import { Grid, Typography, Box } from "@mui/material";
import React, { useState } from "react";
import { Radar, RadarChart,Tooltip, PolarGrid, PolarAngleAxis, PolarRadiusAxis } from 'recharts';
import _ from "lodash";

const labelMap = {
  "Conscientiousness" : "Conscientiousness",
  "Interpersonal Orientation" : "Interpersonal",
  "Adjustment": "Adjustment",
  "Social Influence": "Social",
  "Achievement Orientation" : "Achievement",
  "Practical Intelligence": "Intelligence",
  "Independence" : "Independence" 
}

export const StylesRadar = ({ data }) => { 
  
  const [difference, setDifference] = useState("Please click chart");
  const [yourValue, setYourValue] = useState("Please click chart");
  const [jobValue, setJobValue] = useState("Please click chart");
  // let [missionValue, setMissionValue] = React.useState("");
  // let [missionDescription, setMissionDescription] = React.useState("");
  const [textColor, setTextColor] = useState("#000000");

  const clickEvent = (e) => {
    let selected = false;
    if (e && e.activeLabel){
      _.each(data, (d) => {
        if (d.label === e.activeLabel){
          selected = d;
        }
      });
      if (selected){
        difference = (selected.You - selected.Vacancy);
        let differenceNumber = difference;
        difference = difference.toFixed(1) + "%";
        setDifference(difference);
        setYourValue(`${selected.label} : ${selected.You}%`)
        setJobValue(`${selected.label} : ${selected.Vacancy}%`)

        if (differenceNumber < 0){
          // setMissionDescription(`Click here for ${selected.label} Missions`)
          // setMissionValue(selected.label);
          setTextColor("#E16618")
        } else {
          // setMissionDescription(``)
          // setMissionValue("");
          setTextColor("#87D190")
        }

      }
    }
  }


  return (
    <Grid container sx={{ overflowY: 'auto', overflowX: 'hidden', height: "100%" }}>
    <Grid item size={{xs:12}} sm={12} md={12}>
      <div style={{
        height: 220,
        position: "relative",
        minWidth: 280,
        maxWidth: 450,
        left: "20%",
        zIndex: 1
      }}>
        <RadarChart onClick={clickEvent} cx={150} cy={100} outerRadius={75} width={350} height={200} data={data.map(item => ({...item, label: labelMap[item.label]}))}>
          <PolarGrid />
          <PolarAngleAxis dataKey="label"   style={{
          fontSize: '10px',
          fontFamily: 'Montserrat'
      }}/>
          <PolarRadiusAxis angle={90} domain={[0, 100]} />
          <Radar name="You" dataKey="You" stroke="#000000" fill="#DDE0E5" fillOpacity={1.0} />
          <Radar name="Vacancy" dataKey="Vacancy" stroke="#000000" fill="#FF9800" fillOpacity={0.4} />
          <Tooltip />
        </RadarChart>
      </div>
      </Grid>
        {/* <Grid item size={{xs:12}} sm={12} md={4}>
            ...
        </Grid> */}
        <Grid item size={{xs:12}} sm={12} md={12}>
          <Box sx={{ textAlign: "center" }}>
            <Typography sx={{ mt: 1.875 }}> Your Profile </Typography>
            <Typography variant="body2" sx={{ mt: 1.875, mb: 1.875 }}> {yourValue} </Typography>
            <Typography> Job Requirement</Typography>
            <Typography variant="body2" sx={{ mt: 1.875, mb: 1.875 }}> {jobValue} </Typography>
            <Typography> Styles Gap </Typography>
            <Typography variant="body2" style={{"color": textColor}}  sx={{ mt: 1.875, mb: 1.875 }}> {difference} </Typography>
          </Box>
          <Grid container justifyContent="center"  spacing={4}>
            <Grid style={{height: 100}} item size={{xs:12}}></Grid>
          </Grid>
        </Grid>
    </Grid>
  );
};
